// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"GQ-z","inlineTitle":"HQ-z","sponsoredAdsWrapper":"IQ-z","marketplaceRecosWrapper":"JQ-z"};